/* CN.STUDIO — THEME JS */

document.addEventListener('DOMContentLoaded', () => {
  initScrollReveal();
  initStickyHeader();
  initMobileNav();
  initLookbookSlider();
  initPdpGallery();
  initPdpAccordions();
  initPdpSizeBtns();
  initCartDrawer();
  initAtcIntercept();
});

/* Scroll Reveal */
function initScrollReveal() {
  const els = document.querySelectorAll('.rv');
  if (!els.length) return;
  const obs = new IntersectionObserver((entries) => {
    entries.forEach(e => {
      if (e.isIntersecting) {
        e.target.classList.add('on');
        obs.unobserve(e.target);
      }
    });
  }, { threshold: 0.08, rootMargin: '0px 0px -32px 0px' });
  els.forEach(el => obs.observe(el));
}

/* Sticky Header */
function initStickyHeader() {
  const header = document.querySelector('nav#nav');
  if (!header) return;
  const bar = document.querySelector('.bar');
  const barH = bar ? bar.offsetHeight : 0;
  const update = () => {
    header.classList.toggle('stuck', window.scrollY > barH + 10);
  };
  window.addEventListener('scroll', update, { passive: true });
  update();
}

/* Mobile Nav */
function initMobileNav() {
  const hamburger = document.querySelector('.hamburger');
  const mobileNav = document.querySelector('.mobile-nav-overlay');
  if (!hamburger || !mobileNav) return;
  hamburger.addEventListener('click', () => {
    const open = mobileNav.classList.toggle('open');
    hamburger.classList.toggle('open');
    mobileNav.setAttribute('aria-hidden', open ? 'false' : 'true');
    document.body.style.overflow = open ? 'hidden' : '';
  });
  mobileNav.querySelectorAll('a').forEach(a => {
    a.addEventListener('click', () => {
      mobileNav.classList.remove('open');
      hamburger.classList.remove('open');
      mobileNav.setAttribute('aria-hidden', 'true');
      document.body.style.overflow = '';
    });
  });
}

/* Lookbook Slider */
function initLookbookSlider() {
  const slider = document.querySelector('.gallery-slider');
  if (!slider) return;

  const track = slider.querySelector('.gallery-track');
  const slides = Array.from(slider.querySelectorAll('.gallery-slide'));
  const prevBtn = slider.querySelector('.gallery-btn.prev');
  const nextBtn = slider.querySelector('.gallery-btn.next');
  const dots = Array.from(slider.querySelectorAll('.gallery-dot'));
  const counter = slider.querySelector('.gallery-counter');

  if (!slides.length) return;

  let current = 0;
  const total = slides.length;

  function getSlideWidth() {
    return slides[0].offsetWidth + 2;
  }

  function goTo(idx) {
    current = Math.max(0, Math.min(idx, total - 1));
    track.style.transform = `translateX(-${current * getSlideWidth()}px)`;
    dots.forEach((d, i) => d.classList.toggle('active', i === current));
    if (counter) {
      counter.textContent = `${String(current + 1).padStart(2, '0')} / ${String(total).padStart(2, '0')}`;
    }
    if (prevBtn) prevBtn.disabled = current === 0;
    if (nextBtn) nextBtn.disabled = current === total - 1;
  }

  if (prevBtn) prevBtn.addEventListener('click', () => goTo(current - 1));
  if (nextBtn) nextBtn.addEventListener('click', () => goTo(current + 1));
  dots.forEach((d, i) => d.addEventListener('click', () => goTo(i)));

  /* Touch swipe */
  let startX = 0;
  track.addEventListener('touchstart', e => { startX = e.touches[0].clientX; }, { passive: true });
  track.addEventListener('touchend', e => {
    const diff = startX - e.changedTouches[0].clientX;
    if (Math.abs(diff) > 44) goTo(diff > 0 ? current + 1 : current - 1);
  });

  window.addEventListener('resize', () => goTo(current));
  goTo(0);
}

/* PDP Swipe Gallery */
function initPdpGallery() {
  const slides = document.getElementById('pdpSlides');
  if (!slides) return;
  const dots = Array.from(document.querySelectorAll('.pdp-dot'));
  const total = slides.children.length;
  let current = 0, startX = 0, dragging = false, dragDelta = 0;

  function goTo(idx) {
    current = Math.max(0, Math.min(idx, total - 1));
    slides.style.transform = `translateX(-${current * 100}%)`;
    dots.forEach((d, i) => d.classList.toggle('active', i === current));
  }

  dots.forEach((d, i) => d.addEventListener('click', () => goTo(i)));

  slides.addEventListener('touchstart', e => { startX = e.touches[0].clientX; }, { passive: true });
  slides.addEventListener('touchend', e => {
    const diff = startX - e.changedTouches[0].clientX;
    if (Math.abs(diff) > 40) goTo(diff > 0 ? current + 1 : current - 1);
  });

  slides.addEventListener('mousedown', e => { dragging = true; startX = e.clientX; slides.style.transition = 'none'; });
  window.addEventListener('mousemove', e => { if (dragging) dragDelta = e.clientX - startX; });
  window.addEventListener('mouseup', () => {
    if (!dragging) return;
    dragging = false;
    slides.style.transition = '';
    if (Math.abs(dragDelta) > 60) goTo(dragDelta < 0 ? current + 1 : current - 1);
    else goTo(current);
    dragDelta = 0;
  });
}

/* PDP Accordions */
function initPdpAccordions() {
  document.querySelectorAll('.pdp-acc-head').forEach(btn => {
    btn.addEventListener('click', () => {
      const body = btn.nextElementSibling;
      const open = btn.getAttribute('aria-expanded') === 'true';
      btn.setAttribute('aria-expanded', !open);
      body.classList.toggle('open', !open);
    });
  });
}

/* PDP Size Buttons */
function initPdpSizeBtns() {
  const btns = Array.from(document.querySelectorAll('.pdp-size-btn'));
  const variantInput = document.getElementById('variant-id');
  btns.forEach(btn => {
    btn.addEventListener('click', () => {
      if (btn.classList.contains('unavail')) return;
      btns.forEach(b => b.classList.remove('active'));
      btn.classList.add('active');
      if (variantInput) variantInput.value = btn.dataset.variantId;
    });
  });
}

/* ─────────────────────────────────────────────────────────────
   CART DRAWER — right-side slide-in, AJAX-driven
   ───────────────────────────────────────────────────────────── */
function initCartDrawer() {
  const drawer = document.getElementById('cart-drawer');
  if (!drawer) return;

  const body = document.getElementById('cart-drawer-body');
  const foot = document.getElementById('cart-drawer-foot');
  const heading = document.getElementById('cart-drawer-heading');
  const subtotalEl = document.getElementById('cart-drawer-subtotal');
  const bagCount = document.getElementById('bag-count');

  function openDrawer() {
    drawer.classList.add('open');
    drawer.setAttribute('aria-hidden', 'false');
    document.body.style.overflow = 'hidden';
    refreshCart();
  }
  function closeDrawer() {
    drawer.classList.remove('open');
    drawer.setAttribute('aria-hidden', 'true');
    document.body.style.overflow = '';
  }

  // Expose opener globally so ATC intercept can use it
  window.CNCart = { open: openDrawer, close: closeDrawer, refresh: refreshCart };

  // Open: bag icon and any [data-open-cart] element
  document.addEventListener('click', (e) => {
    const opener = e.target.closest('[data-open-cart]');
    if (opener) {
      e.preventDefault();
      openDrawer();
    }
  });

  // Close: backdrop, X button, escape
  drawer.querySelectorAll('[data-close-cart]').forEach(el => {
    el.addEventListener('click', closeDrawer);
  });
  document.addEventListener('keydown', (e) => {
    if (e.key === 'Escape' && drawer.classList.contains('open')) closeDrawer();
  });

  function formatMoney(cents) {
    const n = (cents / 100).toFixed(2);
    return '$' + n + ' AUD';
  }

  async function refreshCart() {
    body.innerHTML = '<div class="cart-drawer-loading">Loading…</div>';
    try {
      const res = await fetch('/cart.js', { headers: { 'Accept': 'application/json' } });
      const cart = await res.json();
      renderCart(cart);
      updateBagCount(cart.item_count);
    } catch (err) {
      body.innerHTML = '<div class="cart-drawer-loading">Could not load your bag.</div>';
    }
  }

  function renderCart(cart) {
    if (cart.item_count === 0) {
      heading.textContent = 'Empty.';
      body.innerHTML = `
        <div class="cart-drawer-empty">
          <p class="cart-empty-line">Nothing here yet.</p>
          <p class="cart-empty-sub">The good ones are still on the rack.</p>
          <a href="/#collection" class="btn btn-solid" data-close-cart-link>Shop Drop 001</a>
        </div>`;
      foot.hidden = true;
      // Close drawer when the shop link is clicked (smooth UX)
      body.querySelector('[data-close-cart-link]')?.addEventListener('click', closeDrawer);
      return;
    }

    heading.textContent = cart.item_count + ' ' + (cart.item_count === 1 ? 'piece' : 'pieces');

    body.innerHTML = cart.items.map((item, idx) => {
      const lineIdx = idx + 1;
      const variantLabel = (item.variant_title && item.variant_title !== 'Default Title') ? item.variant_title : '';
      const imgSrc = item.image ? item.image + (item.image.includes('?') ? '&' : '?') + 'width=200' : '';
      return `
        <div class="cart-drawer-item" data-line="${lineIdx}">
          <a href="${item.url}" class="cart-drawer-item-img" data-close-cart-link>
            ${imgSrc ? `<img src="${imgSrc}" alt="${escapeHtml(item.product_title)}">` : ''}
          </a>
          <div>
            <a href="${item.url}" class="cart-drawer-item-name" data-close-cart-link>${escapeHtml(item.product_title)}</a>
            ${variantLabel ? `<div class="cart-drawer-item-variant">${escapeHtml(variantLabel)}</div>` : ''}
            <div class="cart-drawer-item-price">${formatMoney(item.line_price)}</div>
            <div class="cart-drawer-item-controls">
              <div class="cart-drawer-qty">
                <button type="button" data-line="${lineIdx}" data-qty="${item.quantity - 1}" aria-label="Decrease">−</button>
                <span class="cart-drawer-qty-n">${item.quantity}</span>
                <button type="button" data-line="${lineIdx}" data-qty="${item.quantity + 1}" aria-label="Increase">+</button>
              </div>
              <button type="button" class="cart-drawer-item-remove" data-line="${lineIdx}" data-qty="0">Remove</button>
            </div>
          </div>
        </div>`;
    }).join('');

    subtotalEl.textContent = formatMoney(cart.total_price);
    foot.hidden = false;

    // Wire qty + remove
    body.querySelectorAll('button[data-line]').forEach(btn => {
      btn.addEventListener('click', async () => {
        const line = parseInt(btn.dataset.line, 10);
        const qty = parseInt(btn.dataset.qty, 10);
        try {
          const res = await fetch('/cart/change.js', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
            body: JSON.stringify({ line, quantity: qty })
          });
          const cart = await res.json();
          renderCart(cart);
          updateBagCount(cart.item_count);
        } catch (err) {}
      });
    });

    // Item link/image closes drawer (lets the navigation happen naturally)
    body.querySelectorAll('[data-close-cart-link]').forEach(el => {
      el.addEventListener('click', closeDrawer);
    });
  }

  function updateBagCount(n) {
    if (!bagCount) return;
    bagCount.textContent = n;
    if (n > 0) bagCount.removeAttribute('hidden');
    else bagCount.setAttribute('hidden', '');
  }
}

/* Intercept all /cart/add form posts: AJAX-add and open the drawer */
function initAtcIntercept() {
  document.addEventListener('submit', async (e) => {
    const form = e.target;
    if (!(form instanceof HTMLFormElement)) return;
    if (form.getAttribute('action') !== '/cart/add') return;

    const variantInput = form.querySelector('input[name="id"]');
    if (!variantInput || !variantInput.value) return;

    e.preventDefault();

    const btn = form.querySelector('.pdp-atc, button[type="submit"]');
    const btnText = btn?.querySelector('.pdp-atc-text');
    const originalText = btnText ? btnText.textContent : (btn ? btn.textContent : '');
    if (btn) btn.disabled = true;
    if (btnText) btnText.textContent = 'Adding…';

    try {
      const formData = new FormData(form);
      const res = await fetch('/cart/add.js', {
        method: 'POST',
        body: formData,
        headers: { 'Accept': 'application/json' }
      });
      if (res.ok) {
        if (btnText) btnText.textContent = '◆ Added';
        if (window.CNCart) window.CNCart.open();
        setTimeout(() => {
          if (btnText) btnText.textContent = originalText;
          if (btn) btn.disabled = false;
        }, 1600);
      } else {
        const err = await res.json().catch(() => ({}));
        if (btnText) btnText.textContent = err.description || 'Unable to add';
        setTimeout(() => {
          if (btnText) btnText.textContent = originalText;
          if (btn) btn.disabled = false;
        }, 2200);
      }
    } catch {
      if (btnText) btnText.textContent = originalText;
      if (btn) btn.disabled = false;
    }
  });
}

function escapeHtml(str) {
  return String(str || '')
    .replace(/&/g, '&amp;')
    .replace(/</g, '&lt;')
    .replace(/>/g, '&gt;')
    .replace(/"/g, '&quot;')
    .replace(/'/g, '&#39;');
}
